export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10479.c3c60c53.jpg";